import { StringColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	segmentName: 'segmentName'
};

export const columnConfigs = [
	StringColumn({
		title: 'Segment Name',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.segmentName] || EMPTY_STRING
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 500
	}
};
